export default __webpack_public_path__ + "static/hosting-shape9-618e8eb2ae8e6fd2a4583bd44d815448.png";